// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kj-c";
export var backButton = "_kj-4";
export var backIcon = "_kj-5";
export var chevronShortcut = "_kj-6";
export var container = "_kj-1";
export var editor = "_kj-8";
export var editorWrapper = "_kj-7";
export var prefix = "_kj-2";
export var searchIcon = "_kj-3";
export var suffix = "_kj-9";
export var suffixContent = "_kj-a";
export var suffixText = "_kj-b";
export var wrapper = "_kj-0";